import { Chat } from './chat';
import { useAgent } from './context/agent';

export const Component = () => {
  const agent = useAgent();
  return <Chat agent={agent} />;
};
